module.exports = __webpack_public_path__ + "static/orwell-3e8f2cd3d0b11c8c10727383f2d95010.webp";